import { render, staticRenderFns } from "./BacTable.vue?vue&type=template&id=4cad2a84&"
import script from "./BacTable.vue?vue&type=script&lang=ts&"
export * from "./BacTable.vue?vue&type=script&lang=ts&"
import style0 from "./BacTable.vue?vue&type=style&index=0&id=4cad2a84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports